import store from "@/store";
// 处理树形结构
function treeFilter(arr, result = []) {
  arr.forEach((item) => {
    // result.push({
    //   value: item.value,
    //   label: item.label,
    // });
    result.push(item);
    if (item.children) {
      treeFilter(item.children, result);
    }
  });
  return result;
}
//处理图片路径带不带http://和https://
function urlFilter(url) {
  if (
    !url ||
    url[0] == "/" ||
    url.indexOf("http://") != -1 ||
    url.indexOf("https://") != -1 ||
    url.indexOf("data:image") != -1
  ) {
    return url;
  } else {
    return store.state.ip + url;
  }
}
//用户权限状态
function checkGrants(grants,grant) {
  if (grants == "*") {
    return true;
  } else {
    grants = (grants||"").split(",");
    return !!grants.find((item) => item == grant);
  }
}
//用户权限状态
function servicesState(permissions) {
  let services = store.state.pages.services;
  if (services == "*") {
    return true;
  } else {
    services = (services || "").split(",");
    return services.find((item) => item == permissions);
  }
}
//登录用户权限状态
function logingrantsState(permissions) {
  let grants = store.state.loginGrant.grants || "";
  if (grants == "*") {
    return true;
  } else {
    grants = grants.split(",");
    return grants.find((item) => item == permissions);
  }
}

//节流
function throttle(time, fn, bind) {
  var last_exec_time;
  return function () {
    var now = Date.now();
    if (last_exec_time && now - last_exec_time < time) return false;

    fn.apply(bind, arguments);
  };
}
//防抖
function debounce(time, fn, bind) {
  let timer;
  return function () {
    if (timer) clearTimeout(timer);
    let args = arguments;
    timer = setTimeout(() => {
      fn.apply(bind, args);
    }, time);
  };
}

//隐藏手机号中间几位
export function phoneFilter(phone) {
  return `${phone.slice(0, 3)}****${phone.slice(-4)}`;
}

//判断手机号运营商
export function phoneJudge(phone) {
  let isChinaMobile = /^1(3[4-9]|5[012789]|8[23478]|4[7]|7[28]|9[578])\d{8}$/;//中国移动通信
  let isChinaUnion = /^1(3[0-2]|5[56]|8[56]|4[5]|7[156]|6[6]|9[6])\d{8}$/;//中国联通产品
  let isChinaTelcom = /^1(3[3])|(5[3])|(7[37])|(8[019])|(9[039])\d{8}$/; ///^(?:133|153|17[37]|18[019])\\d{8}$/; //1349号段 /^1(3[3])|(8[019])\d{8}$/;//中国电信产品
  let isOtherTelphone = /^170([059])\d{7}$/; //其他运营商
  if (isChinaMobile.test(phone)) {
    return "中国移动";
  } else if (isChinaUnion.test(phone)) {
    return "中国联通";
  } else if (isChinaTelcom.test(phone)) {
    return "中国电信";
  } else if (isOtherTelphone.test(phone)) {
    return "其他运营商";
  } else {
    return false;
  }
}
//深度拷贝
function deepClone(target, map = new WeakMap()) {
  // 处理基本类型和 null/undefined
  if (target === null || typeof target !== 'object') {
    return target;
  }

  // 处理循环引用
  if (map.has(target)) {
    return map.get(target);
  }

  // 处理日期对象
  if (target instanceof Date) {
    return new Date(target);
  }

  // 处理正则表达式
  if (target instanceof RegExp) {
    return new RegExp(target.source, target.flags);
  }

  // 处理 Set
  if (target instanceof Set) {
    const cloneSet = new Set();
    map.set(target, cloneSet);
    target.forEach(value => {
      cloneSet.add(deepClone(value, map));
    });
    return cloneSet;
  }

  // 处理 Map
  if (target instanceof Map) {
    const cloneMap = new Map();
    map.set(target, cloneMap);
    target.forEach((value, key) => {
      cloneMap.set(deepClone(key, map), deepClone(value, map));
    });
    return cloneMap;
  }

  // 处理数组和普通对象
  const cloneObj = Array.isArray(target) ? [] : {};
  map.set(target, cloneObj);

  // 递归拷贝所有属性
  for (const key in target) {
    if (target.hasOwnProperty(key)) {
      cloneObj[key] = deepClone(target[key], map);
    }
  }

  // 处理 Symbol 类型属性（额外处理）
  const symbolKeys = Object.getOwnPropertySymbols(target);
  for (const symKey of symbolKeys) {
    cloneObj[symKey] = deepClone(target[symKey], map);
  }

  return cloneObj;
}

//将方法暴露出来
export default {
  treeFilter,
  urlFilter,
  checkGrants,
  servicesState,
  debounce,
  throttle,
  logingrantsState,
  phoneFilter,
  phoneJudge,
  deepClone
};
